import useSWR from "swr";
import axios from "axios";

function useResume({ shouldFetch = true, labourerId }) {
  return useSWR(
    shouldFetch ? [`${process.env.REACT_APP_API_URL}/resumes`, labourerId] : null,
    async ([url, labourerId]) => {
      const params = new URLSearchParams();

      if (labourerId) params.append('labourerId', labourerId);

      const { data: { resume } } = await axios.get(`${url}?${params.toString()}`);

      return { resume };
    }
  );
}

export default useResume;
